var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrowDownGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.212 12.709c-.39.39-1.025.39-1.416 0l-.003.003-6-6a1.002 1.002 0 0 1 1.416-1.416l5.293 5.29 5.294-5.293a1.002 1.002 0 0 1 1.416 1.416l-6 6Z",
    fill: "#1AA758"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.212 18.707c-.39.39-1.025.39-1.416 0l-.003.003-6-6a1.001 1.001 0 0 1 1.416-1.416l5.293 5.291 5.294-5.294a1.002 1.002 0 0 1 1.416 1.416l-6 6Z",
    fill: "#1AA758"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowDownGreenIcon);
export default __webpack_public_path__ + "static/media/double-arrow-down-green-icon.557b93e8722b75da029650e89665ac0f.svg";
export { ForwardRef as ReactComponent };